import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper/modules';

import '../assets/Upcoming.css';
import mangoFarm from '../assets/imgs/mangoFarm.webp';
import saswad from '../assets/imgs/saswadi.webp';
import bhatghar from '../assets/imgs/Bhatghar_Dam1.webp';
import gujarwadi from '../assets/imgs/gujarwadi.webp';
import donje from '../assets/imgs/donje.webp';
import gunjawani from '../assets/imgs/Gunjawani.webp';
import kamshet from '../assets/imgs/kamshet.webp';
import Mahabaleshwar from '../assets/imgs/mahabaleshwar.webp';
// import whatsapp from '../assets/imgs/whats-app-icon.webp';
import Whatsapp from './Whatsapp';
const projectData = [
  {
    name: 'Hinjewadi',
    area: '',
    type: '',
    img: saswad,
    direction: 'left'
  },
  {
    name: 'Konkan',
    area: '771 Acres',
    type: 'Mango Farm Plots',
    img: mangoFarm,
    direction: 'left'
  },
  {
    name: 'Lonavala Pawna',
    area: 'Dam 30 Acres',
    type: 'Villas and Farmhouse Plots',
    img: saswad,
    direction: ''
  },
  {
    name: 'Lonavala, Pawna Dam',
    area: '13 Acres',
    type: 'Villas',
    img: saswad,
    direction: ''
  },
  {
    name: 'Hinjewadi',
    area: '150 Acres',
    type: 'Farm Plots & Villas Project',
    img: saswad,
    direction: 'right'
  },
  {
    name: 'Navi Peth',
    area: 'Pune',
    type: 'Residential Apartment',
    img: gujarwadi,
    direction: 'left'
  },
  {
    name: 'Konkan',
    area: '300 Acres',
    type: 'Timber Plants Farm Plots',
    img: saswad
  },
  {
    name: 'Varve',
    area: 'Khed Shivapur',
    type: 'Bungalow Plots',
    img: saswad
  },
  {
    name: 'Bhatghar Dam',
    area: 'Touch 150 Sanction',
    type: 'Bungalows',
    img: bhatghar,
    direction: 'right'
  },
  {
    name: 'Velhe, Tambhad / Sonde',
    area: '240 Acres',
    type: 'Farm Plots',
    img: donje,
    direction: 'left'
  },
  {
    name: 'Velhe, Advali',
    area: '30 Acres',
    type: 'Farm Plots',
    img: saswad
  },
  {
    name: 'Saswad Hivre',
    area: '',
    type: 'Bungalow Plots',
    img: saswad
  },
  {
    name: 'Velhe, Gunjawani Dam',
    area: '50 Acres',
    type: 'Farm Plots & Villas',
    img: gunjawani,
    direction: 'left'
  },
  {
    name: 'Warje',
    area: '',
    type: 'Residential Apartment',
    img: gujarwadi,
    direction: 'left'
  },
  {
    name: 'Donje / Sinhgad Fort',
    area: '',
    type: 'Sanctioned Bungalow & Farm Plots',
    img: saswad
  },
  {
    name: 'Bhor, Shirgaon',
    area: '100 Acres',
    type: 'Farm Plotting Project',
    img: saswad
  },
  {
    name: 'Lonavala Kamshet',
    area: '60 Acres',
    type: 'Farm House Plotting Projects',
    img: kamshet,
    direction: 'left'
  }
];

function UpComingProjects() {
  return (


    <>


      <div className="u-project-container">
        <h2 className="u-project-head">
          Upcoming <span>Projects</span>
        </h2>

        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="project-swiper"
        >
          {projectData.map((project, index) => (
            <SwiperSlide key={index}>
              <div className="u-project">
                {project.img && (
                  <div className="u-project-image">
                    <img src={project.img} loading="lazy" alt={project.name} />
                  </div>
                )}
                <div className="u-project-info pf1">
                  <h2>{project.name}</h2>
                  {project.area && <p>{project.area}</p>}
                  {project.type && <p>{project.type}</p>}
                  {project.direction && (
                    <p className="u-parrow">
                      {project.direction === 'left' ? '←' : '→'}
                    </p>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>




      <Whatsapp />

    </>



  );
}

export default UpComingProjects;
